import image0 from "./images/tessl.png";
import image1 from "./images/duna.png";
import image2 from "./images/telegraph.png";
import image3 from "./images/chargetrip.png";
import image4 from "./images/eventlink.png";
import image5 from "./images/understory.png";
import image6 from "./images/no-ga.png";
import image7 from "./images/linearity.png";
import image8 from "./images/evgo-fast-charging.png";
import image9 from "./images/zalando.png";
import image10 from "./images/azuga.png";
import image11 from "./images/bridgestone.png";
import image12 from "./images/nextroll.png";
import image13 from "./images/digibee.png";

export const trustedByLogos = [
  {"logo": { "src": image0.src,"alt": "Tessl", "width": 786, "height": 200}},
  {"logo": { "src": image1.src,"alt": "Duna", "width": 746, "height": 200}},
  {"logo": { "src": image2.src,"alt": "Telegraph", "width": 1186, "height": 201}},
  {"logo": { "src": image3.src,"alt": "Chargetrip", "width": 1090, "height": 200}},
  {"logo": { "src": image4.src,"alt": "Eventlink", "width": 1231, "height": 187}},
  {"logo": { "src": image5.src,"alt": "Understory", "width": 1132, "height": 200}},
  {"logo": { "src": image6.src,"alt": "NO GA", "width": 1122, "height": 200}},
  {"logo": { "src": image7.src,"alt": "Linearity", "width": 1483, "height": 303}},
  {"logo": { "src": image8.src,"alt": "EVgo Fast Charging", "width": 1024, "height": 630}},
  {"logo": { "src": image9.src,"alt": "Zalando", "width": 320, "height": 62}},
  {"logo": { "src": image10.src,"alt": "Azuga", "width": 250, "height": 76}},
  {"logo": { "src": image11.src,"alt": "Bridgestone", "width": 400, "height": 48}},
  {"logo": { "src": image12.src,"alt": "NextRoll", "width": 350, "height": 52}},
  {"logo": { "src": image13.src,"alt": "Digibee", "width": 8192, "height": 1951}},
];
